/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_ResultsInputs */



/**
* | output |
* | --- |
* | "Export Results" |
*
* @param {Export_ResultsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const export_results = /** @type {((inputs?: Export_ResultsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_ResultsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exporter les résultats")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ergebnisse exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esporta risultati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Результаты экспорта")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultados de exportación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("出口结果")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポート結果")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात परिणाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Resultados da Exportação")
	return /** @type {LocalizedString} */ ("Export Results")
});